import type { DefaultSeoProps } from 'next-seo';

import { toAbsoluteUrl } from './urls';

/**
 * Site wide social share card, used as the fallback og:image and twitter:image for every page that
 * does not set its own (blog posts set theirs from the article image).
 *
 * Currently null: the repository holds no 1200x630 brand asset. /static/logo.png is 59x48 and the
 * page hero images on the CDN are 1182x988, so both would be cropped badly by the 1.91:1 crop that
 * Facebook, LinkedIn, Slack and X apply. Drop a proper card into /public/static and set this
 * constant to it; every page then picks it up with no further changes.
 */
export const SocialShareImage: { url: string; width: number; height: number; alt: string } | null = null;

// NOTE: `canonical` is deliberately NOT set here. next-seo applies DefaultSeo values to every
// page, so a canonical defined at this level pointed every page (including every blog post) at
// the homepage. Each page now supplies its own canonical via the per page SEO config helpers.
const defaultSeoConfig: DefaultSeoProps = {
  title: 'Gaspar AI',
  themeColor: '#ffffff',
  openGraph: {
    type: 'website',
    locale: 'en_IE',
    url: toAbsoluteUrl('/'),
    title: 'Gaspar AI',
    siteName: 'Gaspar AI',
    ...(SocialShareImage ? { images: [SocialShareImage] } : {}),
  },
  twitter: {
    handle: '@gaspardesk1',
    site: '@gaspardesk1',
    cardType: 'summary_large_image',
  },
};
export default defaultSeoConfig;
